module.exports = __webpack_public_path__ + "static/media/maera.3f7677dd.pdf";